import { render, staticRenderFns } from "./AuthorizationsList.vue?vue&type=template&id=54354a3a&scoped=true&"
import script from "./AuthorizationsList.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsList.vue?vue&type=style&index=0&id=54354a3a&lang=scss&scoped=true&"
import style1 from "./AuthorizationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54354a3a",
  null
  
)

export default component.exports